export default __webpack_public_path__ + "static/8_30-f9b1951ccb2e09c6ef6b24ec2a138ffd.png";